<div [ngClass]="activeToggleClasses">
  <div class="wpdh-container">
    <router-outlet></router-outlet>
  </div>
</div>
<app-breakpoint></app-breakpoint>
<app-search-window *ngIf="globals.isBrowser"></app-search-window>
<loader [loadingContent]="loadingContent"></loader>